module.exports = __webpack_public_path__ + "img/2.fdfad42c.jpg";